module.exports = __webpack_public_path__ + "static/media/icone-remover.8440f26b.svg";